import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { tenantApi } from '../tenant';

import {
  projectsApi,
  healthDepartmentsListTag,
  healthDepartmentsTagType,
} from './index';

interface OnQueryStartedArgs {
  dispatch: ThunkDispatch<any, any, UnknownAction>;
  queryFulfilled: Promise<{ data: { tenantId?: string | null } }>;
}

export async function invalidateHealthDepartmentCaches({
  dispatch,
  queryFulfilled,
}: OnQueryStartedArgs): Promise<void> {
  try {
    const { data } = await queryFulfilled;

    // Health Department options are derived from profile-form reference data,
    // so a successful form mutation can change the options for its project.
    if (data.tenantId) {
      try {
        const tenant = await dispatch(
          tenantApi.endpoints.details.initiate(
            { id: data.tenantId },
            { subscribe: false }
          )
        ).unwrap();
        dispatch(
          projectsApi.util.invalidateTags([
            { id: tenant.projectId, type: healthDepartmentsTagType },
          ])
        );
        return;
      } catch {
        // Fall back to the list tag when the target project cannot be resolved.
      }
    }

    dispatch(projectsApi.util.invalidateTags([healthDepartmentsListTag]));
  } catch {
    // Failed form mutations do not change active reference data.
  }
}
